import React from 'react'

export default function Description() {
  return (
    <div className="grid grid-cols-1 gap-2 my-4">
        <p className="text-center font-bold text-lg">
          120 bài thi mô phỏng các tình huống giao thông
        </p>
        <p>
          Theo quy định bắt đầu từ 1/6/2022 sẽ có thêm nội dung học lái xe mô
          phỏng vào chương trình đào tạo lái xe ô tô các hạng. Và từ ngày
          15/6/2022 sẽ chính thức có thêm nội dung thi mô phỏng trong các kì thi
          sát hạch cấp giấy phép lái xe. Việc áp dụng thêm phần thi mô phỏng
          khiến các bạn học viên đang học chương trình cũ, cũng như các bạn
          chuẩn bị học lái xe có một tâm lý chung là hoang mang và lo lắng.Trong
          nội dung này chúng ta sẽ cùng tìm hiểm 120 bài thi mô phỏng các tình
          huống giao sử dụng cho tất cả các hạng lái xe B1 tự động,B2 số sàn và
          hạng C.
        </p>
        <div className="m-auto">
        <img src="https://daotaolaixehd.com.vn/wp-content/uploads/2022/05/120_tinh_huong_giao_thong-420x236.jpg" alt="" />
        </div>
        <p>1. Mục đích xây dựng các video bài thi mô phỏng:</p>
        <ul>
            <li>Giúp học viên làm quen với một số tình huống giao thông phức tạp có thể xảy ra</li>
            <li>Thông qua quá trình ôn tập và kiểm tra, giúp học viên hình thành phản xạ nhận biết một số nguy cơ tiềm ẩn nguy hiểm khi tham gia giao thông</li>
        </ul>
        <p>2. Phương pháp đào tạo:</p>
        <ul>
            <li>Học viên đóng vai trò là lái xe tham gia ở góc nhìn thứ nhất, đặt vào trong các tình huống giao thông khác nhau.</li>
            <li>Học viên phải quan sát, phân tích, nhận biết các mối nguy cơ tiềm tàng, các mối nguy cơ nguy hiểm (có thể dẫn tới tai nạn)</li>
            <li>Học viên phải xác định, trả lời thời điểm cần phải xử lý để phòng tránh được tai nạn có thể xảy ra.</li>
        </ul>
      </div>
  )
}
